import styled, { css } from 'styled-components';
import {GREY_5, GREY, PRIMARY, WHITE, GREY_4} from '../../utils/colors';

const geSeatBackground = (type?: string) => {
  let result = '';

  switch (type) {
    case 'available':
      result = '#E9E9E9';
      break;
    case 'selected':
      result = PRIMARY;
      break;
    case 'booked':
      result = '#2E3A4E'; // Slate/navy background for Booked
      break;
    case 'blocked':
      result = '#B90000';
      break;
    default:
      result = '#E9E9E9';
  }

  return result;
};
const geSeatTextColour = (type?: string) => {
  let result = '';

  switch (type) {
    case 'available':
      result = '#080403';
      break;
    default:
      result = '#fff';
  }

  return result;
};

const getCursorType = (type?: string) => {
  let result = '';

  switch (type) {
    case 'available':
      result = 'pointer';
      break;
    case 'selected':
      result = 'pointer';
      break;
    case 'blocked':
      result = 'not-allowed';
      break;
    case 'booked':
      result = 'not-allowed';
      break;
    default:
      result = 'auto';
  }

  return result;
};

export const Wrapper = styled.div``;

export const PadContentWrapper = styled.div`
  border: 1px solid ${GREY_4};
  background: ${WHITE};
  border-radius: 20px;
  width: fit-content;
  margin: 20px auto;

`;

export const PadWrapper = styled.div<{ column?: number}>`
  padding: 10px;
  width:100%;
  box-sizing: border-box;
  display: grid;
  grid-gap: 5px;
  grid-template-rows: auto;
  justify-content: space-evenly;
  justify-items: center;
  align-items: center;
  ${({ column }) => column && css`
    grid-template-columns: repeat(${column},  minmax(50px, 1fr));

  `}

`;
export const DriverSeatWrapper = styled.div`
  display: inline-block;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  text-align: center;
  color: #080403;
  margin-right: 64px;
  margin-left: 4px;
`;

const getSeatBorderBottom = (status?: string, seatClass?: string) => {
  if (status === 'selected') {
    return 'solid 6px PRIMARY';  
  }
  if (status === 'booked') {
    return 'solid 6px #202632'; // Slate/navy bottom bar
  }
  
  // For available seats, color by class (case-insensitive check)
  const lowerClass = (seatClass || '').toLowerCase();
  switch (lowerClass) {
    case 'business':
      return 'solid 6px #34C759'; // Green bar
    case 'vip':
      return 'solid 6px #7B57FF'; // Purple bar
    case 'normal':
    default:
      return 'solid 6px #B0B0B0'; // Grey bar
  }
};

export const SeatWrapper = styled.div<{ status?: string, isEmpty?: boolean, seatWidth?: string, marginalized?: boolean, isDriver?: boolean, doubleMarginalized?: boolean, seatClass?: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  text-align: center;
  background: #E9E9E9;
  margin: 5px;
  min-width:45px;
  max-width:60px;
  box-sizing: border-box;
  color: #080403;
  border-radius: 12px 12px 4px 4px;
  border-bottom: ${({ status, seatClass }) => getSeatBorderBottom(status, seatClass)};

  ${({ seatWidth }) => seatWidth && css`
    width: ${seatWidth}%;
  `}

  ${({ status }) => status && css`
    background: ${geSeatBackground(status)};
    color: ${geSeatTextColour(status)};
    cursor: ${getCursorType(status)};
  `}

  ${({ isDriver }) => isDriver && css`
    background:  transparent;
    color:  transaparent;
    border: none;
  `}

  ${({ isEmpty }) => isEmpty && css`
    background: transparent !mportant;
    color: transaparent;
    border: none;
    visibility: hidden;

  `}

  ${({ doubleMarginalized }) => doubleMarginalized && css`
    margin-right: 165px !important;
  `}
`;

export const IndicatorWrapper = styled.div`
  text-align: center;
  display: flex;
  column-gap: 20px;
  justify-content: center;
  ${SeatWrapper} {
    width: 40px;
  }
`;

export const IndicatorContent = styled.div`
  text-align: center;
`;

const largeBusContentWrapper = css`
  width: 350px;
`;
const mediumBusContentWrapper = css`
  width: 300px;
`;

const mediumSBusContentWrapper = css`
  width: 250px;
`;

const smallBusContentWrapper = css`
  width: 230px;
`;

export const ContentWrapper = styled.div<{ size: string}>`
  margin: 0 auto;
  width: 242px;

  ${({ size }) => size === 'small' && smallBusContentWrapper}
  ${({ size }) => size === 'medium' && mediumBusContentWrapper}
  ${({ size }) => size === 'medium-s' && mediumSBusContentWrapper}
  ${({ size }) => size === 'large' && largeBusContentWrapper}
`;

// Legend Container & Section elements for SeatSelection matching Figma Image 3
export const LegendContainer = styled.div`
  background: #FFFFFF;
  border: 1px solid #EFEFEF;
  border-radius: 24px;
  padding: 10px;
  margin: 0 auto 20px auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  max-width: 350px;
  box-sizing: border-box;
`;

export const LegendSection = styled.div`
  background: #FAFAFA;
  border-radius: 12px;
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
`;

export const LegendTitle = styled.div`
  font-size: 10px;
  font-weight: 600;
  color: #8E8E93;
  letter-spacing: 0.8px;
  text-transform: uppercase;
`;

export const LegendRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 24px;
  width: 100%;
`;

export const LegendItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: #72737F;
`;

export const LegendColorBar = styled.div<{ color: string }>`
  width: 40px;
  height: 5px;
  border-radius: 3px;
  background: ${({ color }) => color};
`;
